export const ALIGN_OPTIONS = {
  baseline: 'baseline',
  center: 'center',
  end: 'flex-end',
  start: 'flex-start',
  stretch: 'stretch',
} as const;

export const ALIGN_SELF_OPTIONS = {
  auto: '',
  baseline: 'baseline',
  center: 'center',
  end: 'flex-end',
  start: 'flex-start',
  stretch: 'stretch',
} as const;

export const DIRECTION_OPTIONS = {
  column: 'column',
  row: '',
  'column-reverse': 'column-reverse',
  'row-reverse': 'row-reverse',
} as const;

export const JUSTIFY_OPTIONS = {
  around: 'space-around',
  between: 'space-between',
  center: 'center',
  end: 'flex-end',
  start: 'flex-start',
} as const;

export const WRAP_OPTIONS = {
  nowrap: '',
  wrap: 'wrap',
} as const;
